var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppliedicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513028"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1227",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#00C57E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6869 6L8.56309 10.8328L6.125 8.66719L5 9.66719L8.74941 13L14 7L12.6869 6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedicon);
export default __webpack_public_path__ + "static/media/appliedicon.946fa0f75b59b6ecef9b0e3c3a501677.svg";
export { ForwardRef as ReactComponent };